/*    
<summary>
   This functional common component provides us custom input box that allows values based on regex & has error handler that shows validation error. 
   Developer:Aashish Singh, Created Date:30-Oct-2023
</summary>
<returns>Returns JSX</returns>
*/import React, {useState} from "react";
import { injectIntl } from "react-intl";
import { useField } from "formik";
import FormikFormErrorHandler from "./FormikFormErrorHandler";
import FormikRelayInfoFormErrorHandler from "./FormikFormRelayErrorHandler";
import { toHalfWidth } from "../../helpers/validate-helper";

interface IProps {
  children: React.ReactNode;
  className: string;
  errclassname: string | undefined;
  "data-testid"?: string;
  intl: any;
  name: string;
  onBlur: () => void;
  onChange: () => void;
  placeholder: string;
  type: string;
  value: string;
  toLowerCase: boolean;
  disabled: boolean;
  readOnly: boolean;
  spaceAllowed: boolean;
  validcharacter?: Array<string>;
  invalidcharacter?: Array<string>;
  regex: RegExp;
  dontAddZeroAtStart?: boolean;
}

const FormikFormInputMobileNumber = (props: IProps) => {
  const [field, meta, helpers] = useField(props);
  const [isComposing, setIsComposing] = useState(false);
  const errorClass = `${meta.error && meta.touched ? "error" : ""}`;
  const _placeholder = props.placeholder
    ? props.intl.formatMessage({ id: props.placeholder })
    : props.placeholder;

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    let value = event.target.value;
    
    if (!isComposing) {
      value = toHalfWidth(value);
      
      // Add 0 at the start if user hasn't typed it and value is not empty
      if(!props?.dontAddZeroAtStart)
        if (value.length > 0 && value.charAt(0) !== '0') {
          value = '0' + value;
        }
    }
    
    helpers.setValue(value);
  };

  const handleCompositionStart = () => {
    setIsComposing(true);
  };

  const handleCompositionEnd = (event: React.CompositionEvent<HTMLInputElement>) => {
    setIsComposing(false);
    let value = toHalfWidth(event.currentTarget.value);
    
    // Add 0 at the start if user hasn't typed it and value is not empty
    if(!props?.dontAddZeroAtStart)
      if (value.length > 0 && value.charAt(0) !== '0') {
        value = '0' + value;
      }
    
    helpers.setValue(value);
  };

  return (
    <>
      <input
        {...field}
        {...props}
        placeholder={_placeholder}
        className={`${props.className} ${errorClass}`}
        disabled={props.disabled}
        type={props.type}
        readOnly={props.readOnly}
        onChange={handleChange}
        onCompositionStart={handleCompositionStart}
        onCompositionEnd={handleCompositionEnd}
      />
      {props.errclassname !== undefined ||
      props.className === "relay_max_character_error" ? (
        <FormikRelayInfoFormErrorHandler intl={props.intl} meta={meta} />
      ) : (
        <FormikFormErrorHandler intl={props.intl} meta={meta} />
      )}
    </>
  );
};

export default injectIntl(FormikFormInputMobileNumber);